import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

type Props = {
  cancelButton: React.ReactNode
  confirmCb: () => void
}

const NewCrawling: React.FC<Props> = ({ cancelButton, confirmCb }) => {
  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">Another crawling in progress</div>

      <div className="System-dialog__description">
        <p>You have another crawling in progress. Stop it and start new?</p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="New crawling"
            onClick={confirmCb}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}

export default NewCrawling
